module.exports = new __parcel__URL__("atlasCMR.1b2080b0.png").toString();